import React, { useEffect, useState } from "react";
import { Button } from "../../../components/Button";
import ModalForm from "../../../components/ModalForm";

import { useSelector, useDispatch } from "react-redux";
import {
  resetFormData,
  setModal,
  getFormData,
  setFormData,
  submit,
} from "../../../stores/master/programSlice";
import Select from "../../../components/Select";
import { getDataOptions as getDataOptionStation } from "../../../stores/master/stationSlice";

function Form(props) {
  const { formType, dataId } = props;
  const dispatch = useDispatch();
  const openPopup = useSelector((state) => state.popup.openPopup);
  const openModal = useSelector((state) => state.program.openModal);
  const formData = useSelector((state) => state.program.formData);
  const dataOptionStation = useSelector((state) => state.station.dataOptions);
  const [modalTitle, setModalTitle] = useState();

  useEffect(() => {
    dispatch(resetFormData());
    dispatch(getDataOptionStation());

    if (formType === "create") {
      setModalTitle("Add Program");
      dispatch(setFormData({ name: "active", value: 1 }));
    } else {
      setModalTitle("Edit Program");
      dispatch(getFormData({ id: dataId }));
    }
  }, [dispatch, formType, dataId]);

  const handleInput = (e) => {
    dispatch(setFormData(e.target));
  };

  return (
    <>
      {!openPopup.open && openModal && (
        <ModalForm
          modalTitle={modalTitle}
          modalSize="small"
          closeModal={() => dispatch(setModal(false))}
        >
          <div className="w-full">
            <div className="form-group">
              <label className="control-label">
                Program Name <span className="text-danger">*</span>
              </label>
              <input
                id="program_name"
                title="Program Name"
                type="text"
                name="program_name"
                className="form-control"
                value={formData.program_name}
                onChange={handleInput}
                required={true}
              />
            </div>
            <div className="form-group">
              <label className="control-label">
                Station <span className="text-danger">*</span>
              </label>
              <Select
                id="station_id"
                title="Station"
                name="station_id"
                placeholder={"Choose..."}
                defaultValue={dataOptionStation.filter(
                  (option) => option.value === formData.station_id
                )}
                onChange={(e) =>
                  dispatch(setFormData({ name: "station_id", value: e?.value }))
                }
                options={dataOptionStation}
                required={false}
              />
            </div>
            <div className="form-group">
              <label className="control-label">Active</label>
              <div className="form-checkbox">
                <input
                  id="active"
                  title="Active"
                  type="checkbox"
                  name="active"
                  checked={formData?.active?.toString() === "1" ? true : false}
                  onChange={(e) => {
                    if (e.target.checked) {
                      e.target.value = 1;
                    } else {
                      e.target.value = 0;
                    }
                    handleInput(e);
                  }}
                />
              </div>
            </div>
          </div>

          <div className="mt-8 flex gap-2">
            <Button
              title="Save"
              icon="BiSave"
              color="primary"
              onClick={() => dispatch(submit({ formType: formType }))}
            />
            <Button
              title="Cancel"
              icon="BiX"
              color="secondary"
              onClick={() => dispatch(setModal(false))}
            />
          </div>
        </ModalForm>
      )}
    </>
  );
}

export default Form;
